import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { buildQuickLinks } from "@/components/dashboard/QuickLinks";
import { textOf } from "@/lib/search";
import { logWarn } from "@/lib/log";

// Builds the client-side quick-search index (pages, manasik stages, duas, FAQ) once the sheet opens.
export const useSearchIndex = (enabled) => {
  const { t } = useTranslation();
  const { tc } = useLang();
  const [content, setContent] = useState(null);

  useEffect(() => {
    if (!enabled || content) return;
    Promise.all([api.get("/content/stages"), api.get("/content/duas"), api.get("/dynamic/faq")])
      .then(([s, d, f]) => setContent({ stages: s.data.stages || s.data || [], duas: d.data.duas || [], faq: f.data.items || [] }))
      .catch((e) => { logWarn("search index load failed:", e); setContent({ stages: [], duas: [], faq: [] }); });
  }, [enabled, content]);

  const { tiles, rows } = buildQuickLinks(t, tc, 0);
  const pages = [...tiles, ...rows].map((l) => ({ group: "pages", to: l.to, label: l.label, sub: l.hint, hay: `${l.label} ${l.hint}` }));
  const stages = (content?.stages || []).map((s) => ({
    group: "manasik", to: `/guide?trip=${s.type === "hajj" ? "hajj" : "umrah"}&stage=${s.id}`, label: tc(s.title), sub: tc(s.summary),
    hay: `${textOf(s.title)} ${textOf(s.summary)} ${s.id}`,
  }));
  const duas = (content?.duas || []).map((d) => ({
    group: "duas", to: `/prayers?dua=${d.id}`, label: tc(d.title), sub: d.translit || d.category,
    hay: `${textOf(d.title)} ${d.translit || ""} ${textOf(d.translation)} ${d.category || ""}`,
  }));
  const faq = (content?.faq || []).map((f) => ({
    group: "faq", to: "/faq", label: tc(f.title), sub: tc(f.body), hay: `${textOf(f.title)} ${textOf(f.body)}`,
  }));
  return { pages, stages, duas, faq, loading: enabled && !content };
};
